import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Typography, useTheme } from '@mui/material';
import { BLOG_POSTS } from '../../config/blog-posts.data';
import { formatPostDate } from './blog-post.component';

// Lista de todos os posts do blog (mais novos primeiro).
const Blog = () => {
  const theme = useTheme();

  return (
    <Box>
      {/* Hero */}
      <Box sx={{ backgroundColor: theme.palette.text.primary, color: 'white' }}>
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 9 }, textAlign: 'center' }}>
          <Typography variant="h1" sx={{ fontSize: { xs: '2.2rem', md: '3rem' }, mb: 2 }}>
            Blog Assegurados
          </Typography>
          <Typography variant="h4" sx={{ color: theme.palette.grey[100], maxWidth: 680, mx: 'auto' }}>
            Dicas de destinos, roteiros e tudo o que você precisa saber antes de viajar.
          </Typography>
        </Container>
      </Box>

      {/* Lista de posts */}
      <Container maxWidth="lg" sx={{ py: { xs: 5, md: 8 } }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
            gap: 3,
          }}
        >
          {BLOG_POSTS.map((post) => (
            <Box
              key={post.slug}
              component={RouterLink}
              to={`/blog/${post.slug}`}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                textDecoration: 'none',
                color: 'inherit',
                borderRadius: theme.spacingValues.medium,
                backgroundColor: theme.palette.grey[50],
                overflow: 'hidden',
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': { transform: 'translateY(-4px)', boxShadow: 3 },
              }}
            >
              <Box
                component="img"
                src={post.image}
                alt={post.title}
                loading="lazy"
                sx={{ width: '100%', aspectRatio: '1265 / 467', objectFit: 'cover' }}
              />
              <Box sx={{ p: 2.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                  {formatPostDate(post.date)}
                </Typography>
                <Typography variant="h4" sx={{ color: theme.palette.primary.main }}>
                  {post.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: theme.palette.text.secondary,
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                >
                  {post.excerpt}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default Blog;
